import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoadingPage from './LoadingPage';
import OtpPage from './OtpPage';
import PushPage from './PushPage';
import PinPage from './PinPage';
import QuestionPage from './QuestionPage';
import ErrorPage from './ErrorPage';

export const ThreeDSRouter = () => {
  return (
    <Routes>
      <Route path="loading" element={<LoadingPage />} />
      <Route path="otp" element={<OtpPage />} />
      <Route path="push" element={<PushPage />} />
      <Route path="pin" element={<PinPage />} />
      <Route path="question" element={<QuestionPage />} />
      <Route path="error" element={<ErrorPage />} />
      <Route path="*" element={<Navigate to="loading" replace />} />
    </Routes>
  );
};

export default ThreeDSRouter;
